"use strict"; // Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

require("core-js/modules/es.typed-array.set.js");

require("core-js/modules/es.typed-array.sort.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.numToUint8 = void 0;

function numToUint8(num) {
  return new Uint8Array([(num & 0xff000000) >> 24, (num & 0x00ff0000) >> 16, (num & 0x0000ff00) >> 8, num & 0x000000ff]);
}

exports.numToUint8 = numToUint8;